
import React from 'react';
import defaultClasses from './columnGroup.module.css';
import { useStyle } from '../../classify';

const ColumnGroup = props => {
    const classes = useStyle(defaultClasses, props.classes);
    const { display, children } = props;
    const dynamicStyles = {
        display
    };

    return (
        <div style={dynamicStyles} className={classes.root}>
            {children}
        </div>
    );
};

export default ColumnGroup;
